import { IconButton } from "@/components-v2/Button";
import { TMessage } from "@/i18n/tt";
import { stopPropagation } from "@/utils/events";
import { FC } from "react";

export const StarButton: FC<{
  isStarred: boolean;
  onClick: () => void;
  tooltip?: string | TMessage;
}> = ({ isStarred, onClick, tooltip }) => (
  <IconButton
    tooltip={tooltip ?? { key: "star-button.tooltip" }}
    color={"accent3"}
    icon={isStarred ? { name: "star", weight: "fill" } : { name: "star" }}
    onClick={stopPropagation(onClick)}
  />
);
